import { Close } from "@mui/icons-material";
import { Box, Dialog, Typography } from "@mui/material";
import React from "react";
import { colors } from "../../theme/theme";

const TermsAndConditions = ({ open, handleClose, Transition }) => {
  return (
    <Dialog
      fullScreen
      open={open}
      onClose={handleClose}
      TransitionComponent={Transition}
      PaperProps={{
        sx: {
          backgroundColor: "transparent",
          boxShadow: "none",
        },
      }}
      BackdropProps={{
        sx: {
          backgroundColor: "rgba(25,29,41,0.85)",
          backdropFilter: "blur(8px)",
        },
      }}
    >
      <Box sx={{ height: "100%", px: 6, pb: 12 }}>
        <Box
          sx={{
            height: "50px",
            width: "50px",
            borderRadius: "9px",
            backgroundColor: "rgba(255,255,255,0.09)",
            position: "absolute",
            top: "5%",
            right: "2.5%",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            zIndex: 1000,
            cursor: "pointer",
            "&:hover": {
              backgroundColor: "rgba(255,255,255,0.2)",
            },
          }}
          onClick={handleClose}
        >
          <Close sx={{ color: colors.secondary, fontSize: "30px" }} />
        </Box>

        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            // alignItems: "center",
            justifyContent: "center",
            gap: 1,
            mt: 3,
          }}
        >
          <img
            src={require("../../assets/icons/logo_md.png")}
            alt="logo"
            style={{
              height: "50px",
              alignSelf: "flex-start",
              objectFit: "contain",
            }}
          />

          <Typography
            component={"span"}
            sx={{
              color: "#fff",
              fontSize: "42px",
              fontFamily: "Mulish-ExtraBold",
              mt: 2,
            }}
          >
            Terms and Conditions
          </Typography>

          <Typography
            sx={{
              color: "#fff",
              fontSize: "16px",
              fontFamily: "Mulish-Regular",
            }}
          >
            Effective on 12 may 2025
          </Typography>

          <Typography
            sx={{
              color: "#fff",
              fontSize: "16px",
              fontFamily: "Mulish-Regular",
              mt: 2,
            }}
          >
            Welcome to our platform! By using our services, you agree to the
            following terms and conditions. Please read them carefully before
            using our platform. If you do not agree with these terms, please do
            not use our services.
            <br />
            <br />
            1. Acceptance of Terms: By accessing or using our platform, you
            agree to comply with these terms and conditions. If you do not
            agree, you may not use our services.
            <br />
            <br />
            2. User Accounts: You may need to create an account to access
            certain
          </Typography>
        </Box>
      </Box>
    </Dialog>
  );
};

export default TermsAndConditions;
